export default __webpack_public_path__ + "static/media/close-aqua.2cc571e8.svg";